export var CORE_COMPONENT = Symbol('CORE_COMPONENT');
export var CORE_INSTANCE = Symbol('CORE_INSTANCE');
export var CORE_AS_PROPS = Symbol('CORE_AS_PROPS');
export var CORE_INIT = Symbol('CORE_INIT');
export var CONTEXT_COMPONENT = Symbol('CONTEXT_COMPONENT');
export var CREATE_COMPONENT = Symbol('CREATE_COMPONENT');
export var PARENT_COMPONENTS = Symbol('PARENT_COMPONENTS');
//# sourceMappingURL=symbols.mjs.map